const GPT_LANDING_PATHS = ["/gpt", "/gpt/"];

const isCampaignLandingPath = (pagePath = "") =>
  GPT_LANDING_PATHS.includes(pagePath);

module.exports = {
  GPT_LANDING_PATHS,
  isCampaignLandingPath,
};
